<template>
    <div class="tile-body">
        <div class="c-config-content">
            <div class="c-config-content">
                <h5>{{ $t('userEmailList') }}</h5>
                <div v-if="firstLoading">
                    <skeleton-loading>
                        <row>
                            <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                        </row>
                        <row>
                            <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                        </row>
                    </skeleton-loading>
                </div>
                <div v-else>
                    <div class="c-template-table table-responsive c-role-table">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ $t('email') }}</th>
                                    <th>{{ $t('type') }}</th>
                                    <th>{{ $t('time') }}</th>
                                    <th class="text-right th-80">
                                        <span @click="create" class="btn-add"><i class="icon16-plus-circle-gadient"></i></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="listLoading" class="text-center text-primary">
                                <tr>
                                    <th colspan="5">
                            <b-spinner></b-spinner>
                            </th>
                            </tr>
                            </tbody>
                            <tbody v-if="!listLoading && !itemCount" class="text-center">
                                <tr>
                                    <th colspan="4">
                                        {{ $t('noUserEmailFound') }}
                                    </th>
                                </tr>
                            </tbody>
                            <tbody v-if="!listLoading && itemCount">
                                <tr v-for="item in items" :key="item._id">
                                    <td>
                                        <p>{{ item.email }}</p>
                                    </td>
                                    <td>
                                        <p>{{ $t(item.type) }}</p>
                                    </td>
                                    <td>
                                        <p><span class="small text-gray-999">{{$t('createTime')}}: </span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</p>
                                        <p v-if="item.confirmTime"><span class="small text-gray-999">{{$t('confirmTime')}}: </span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</p>
                                    </td>
                                    <td class="text-right">
                                        <button @click="del(item._id)" :disabled="delLoading" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1" type="button">
                                            <b-spinner v-if="delLoading" small></b-spinner>
                                            <i v-else class="icon12-delete-primary"></i>
                                        </button>
                                        <button v-if="!item.confirmTime" @click="update(item._id)" :disabled="updateLoading" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1"
                                                type="button">
                                            <b-spinner v-if="updateLoading" small></b-spinner>
                                            <i v-else class="icon12-edit-primary"></i>
                                        </button>
                                        <button v-if="!item.confirmTime && item.type === 'manual'" :disabled="updateLoading" @click="config(item._id)" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1" type="button">
                                            <b-spinner v-if="updateLoading" small></b-spinner>
                                            {{ $t('tryConfiguring') }}
                                        </button>
                                        <!-- v-if="!item.confirmTime && item.type === 'gmail'"  -->
                                        <button v-if="!item.confirmTime && item.type === 'gmail'" :disabled="updateLoading" @click="submit(item._id)" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1" type="button">
                                            <b-spinner v-if="updateLoading" small></b-spinner>
                                            {{ $t('login') }}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="showForm" :title="$t('addEmail')" @ok="save" no-close-on-backdrop no-enforce-focus>
            <form-select :disabled="formModel.id" :label="$t('type')" :model="formModel" attribute="type" :errors="formErrors" :options="typeOptions"></form-select>

            <form-input v-if="formModel.type === 'manual'" :disabled="formModel.id" :label="$t('email')" :model="formModel" :errors="formErrors" attribute="email" :placeholder="$t('emailPlaceholder')"></form-input>
            <form-input v-if="formModel.type === 'manual'" :label="$t('password')" :model="formModel" :errors="formErrors" attribute="password"></form-input>
            <form-input v-if="formModel.type === 'manual'" :label="$t('host')" :model="formModel" :errors="formErrors" attribute="host"></form-input>
            <form-input v-if="formModel.type === 'manual'" :label="$t('port')" :model="formModel" :errors="formErrors" attribute="port"></form-input>
            <template v-slot:modal-footer>
                <button v-if="formModel.type === 'gmail'" class="btn btn-primary" @click="submit">
                    <i class="fa fa-google-plus"></i>
                    {{ $t('login') }}
                </button>
                <button :disabled="saveLoading" v-if="formModel.type == null || formModel.type === 'manual'" class="btn btn-primary" @click="save">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    {{ $t('tryConfiguringAndSave') }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import CRUD from "@/mixins/CRUD";
    import List from "@/mixins/List";

    export default {
        name: "EmailSender",
        mixins: [CRUD, List],
        data: function () {
            return {
                service: '/client-user-email',
                typeOptions: [
//                    {value: null, text: this.$t('chooseType')},
                    {value: 'gmail', text: this.$t('gmail')},
                    // {value: 'manual', text: this.$t('manual')},
                ],
                defaultFormModel: {
                    type: 'gmail',
                    googleOAuthToken: null
                },
            }
        },
        methods: {
            submit: function () {
                let vue = this;
                this.formModel.googleOAuthToken = null;
                this.$gAuth.getAuthCode(function (code) {
                    vue.formModel.googleOAuthToken = code;
                    vue.save();
                }, function (error) {
                    if(error){
                        vue.$swal({
                            text: 'Chưa hoàn tất việc tích hợp email',
                            icon: 'error'
                        });
                    }
                });
            },
        }
    }
</script>